import React, { useEffect, useState } from 'react';
import { ensureIconSprite, isIconSpriteInDom } from '../lib/icon-sprite.js';

/** Load the icon sprite on first use; re-render when it is ready. */
export function useIconSprite() {
  const [ready, setReady] = useState(isIconSpriteInDom);

  useEffect(() => {
    if (ready) {
      return undefined;
    }

    let active = true;
    ensureIconSprite().then(loaded => {
      if (active && loaded) {
        setReady(true);
      }
    });

    return () => {
      active = false;
    };
  }, [ready]);

  return ready;
}

/** Reference a single symbol from the inlined icon sprite. */
export function SvgUse({ name, ...props }) {
  useIconSprite();

  const href = `#icon-${name}`;
  return <use href={href} xlinkHref={href} {...props} />;
}

/**
 * Renders an icon from the inlined sprite. Symbols use currentColor so
 * fill/stroke follow the CSS `color` on this element or an ancestor.
 */
export default function SvgIcon({
  name,
  className = '',
  width,
  height,
  size,
  viewBox,
  title,
  ...props
}) {
  const resolvedWidth = width ?? size;
  const resolvedHeight = height ?? size;

  return (
    <svg
      width={resolvedWidth}
      height={resolvedHeight}
      viewBox={viewBox}
      className={className}
      role={title ? 'img' : undefined}
      aria-label={title || undefined}
      aria-hidden={title ? undefined : true}
      {...props}>
      <SvgUse name={name} />
    </svg>
  );
}
